import { uuidSchema } from '@engagement-web-app/common/validation-utils';
import { zodValidator } from '@tanstack/zod-adapter';
import z from 'zod';

export const DefaultRouteQueryParams = {
    organizationId: '',
    surveyId: '',
};

export const RouteQueryParams = z.object({
    organizationId: uuidSchema.default(DefaultRouteQueryParams.organizationId),
    surveyId: uuidSchema.default(DefaultRouteQueryParams.surveyId),
});

export const validateSearch = zodValidator(RouteQueryParams);
